/* eslint-disable no-console */

import router from '../router';

// Cache pour éviter de décoder plusieurs fois
let cachedHTTP = null;
let cachedSite = null;

function getSiteFromRoute() {
  try {
    const currentRoute = router.currentRoute;
    const idOpportunite = currentRoute.params.id;

    if (!idOpportunite) {
      return null;
    }

    const decoded = atob(idOpportunite);
    const decodedObject = JSON.parse(decoded);

    return decodedObject.Site || null;
  } catch (error) {
    return null;
  }
}

function getHTTPClient() {
  const currentSite = getSiteFromRoute();

  if (cachedSite === currentSite && cachedHTTP) {
    return Promise.resolve(cachedHTTP);
  }

  // Choisir le bon client HTTP
  if (currentSite === 'girodmedias') {
    return import('./HTTP_GIROMEDIAS').then(module => {
      cachedHTTP = module.default;
      cachedSite = currentSite;
      return module.default;
    });
  }
  return import('./HTTP').then(module => {
    cachedHTTP = module.default;
    cachedSite = currentSite;
    return module.default;
  });
}

const httpRouter = {
  async get(url, config) {
    const HTTP = await getHTTPClient();
    return HTTP.get(url, config);
  },

  async post(url, data, config) {
    const HTTP = await getHTTPClient();
    return HTTP.post(url, data, config);
  },

  async put(url, data, config) {
    const HTTP = await getHTTPClient();
    return HTTP.put(url, data, config);
  },

  async delete(url, config) {
    const HTTP = await getHTTPClient();
    return HTTP.delete(url, config);
  },
};

export default httpRouter;



// WEBPACK FOOTER //
// ./src/api/httpRouter.js